module.exports = "/assets/js/f2b129c148131791637c069c29ecdd4d.svg";